let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lLinc")).then(() => parcelRequire('gOEPf'));